import React from "react";
import { 
  Rocket, 
} from "lucide-react";
import CTAButtonLink from "../CTA/CTAButtonLink.jsx";
import Seo from "../Seo.jsx";
import mainConfig from "../../config/mainConfig"; // adjust the path as needed

import { VerticalBox, VerticalBoxInner } from "../GetStarted/GetStartedHelpers.jsx";
import "../Guides/guides.css";
import "../GetStarted/getStarted.css";
import "./nav-pages.css";
import { Link } from "react-router-dom";

// Import your page config
import pageConfig from "../../config/pageConfig.js";

const CalculatorMain = () => {
  const meta = mainConfig.calculators?.seo || {};

 
  // Convert pageConfig into an array of calculators
  const calculators = Object.values(pageConfig);

  // Group calculators by their sidebar category
  const calculatorsByCategory = calculators.reduce((acc, guide) => {
    const category = guide.sidebar?.category || "Other";
    if (!acc[category]) acc[category] = [];
    acc[category].push(guide);
    return acc;
  }, {});

  return (
    <div className="guides-content guides-content-pad menu-page">
             <Seo title={meta.title} description={meta.description} url={meta.route}/>

      <h1>Calculators</h1>
      <CTAButtonLink 
        to="/get-started/step1"
        text="Understand How Matched Betting Works in 180 Seconds"
        buttonText="Start now"
        icon={Rocket}
        tabText="Popular"
      />


      <h2>All Matched Betting Calculators</h2>
      {Object.entries(calculatorsByCategory).map(([category, guides]) => (
        <div key={category}  style={{ marginBottom: "2.5rem" }}>
          <h3 style={{ marginTop: "2rem" }}>{category}</h3>
          <div className="grid-wrap">
            {guides.map((guide, i) => (
              <div className="col">
              <Link to={guide.route} key={i}>
                <VerticalBox 
                  index={i}
                  content={
                    <VerticalBoxInner 
                      icon={guide.sidebar.icon}
                      title={guide.fullTitle}
                      description={guide.brief}
                    />
                  }
                />
              </Link>

              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CalculatorMain;
